<template>
    <div class="detail-layout">
        <campaign-picture
            class="layout-picture"
            :imgClass="'news'"
            :campaignImage="detailController.campaign.pictures"></campaign-picture>

        <div class="layout-name">{{detailController.campaign.name}}</div>
        <div class="layout-time">
            {{getPublishDate()}}
        </div>

        <detail-and-condition
            :lbl="lbl"
            :userType="userType"
            :campaign="detailController.campaign"></detail-and-condition>
    </div>
</template>
<script>
//plugin
import Moment from 'moment';
//helper
import Util from '@/helper/Utility.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
//component
import CampaignPicture from "../detail/Picture.vue";
import DetailAndCondition from "../detail/DetailAndCondition";
export default {
    name: "DefaultLayout",
    components: {
        CampaignPicture,
        DetailAndCondition
    },
    props: {
        lbl: Object,
        locale: Number,
        userType: String,
        detailController: Object
    },
    data: function() {
        return {
            campaignId: '',
            quantity: 0,
            point: 0,
            price: 0,
            originPrice: 0,
            discount: 0,

            isShowSubcampaign: false,
            subCampaign: null,
            trackingService: new TrackingService(this),
            trackingEventCategory: 'newsdetail_page'
        };
    },
    created: function() {
        this.trackingService.event(this.trackingEventCategory, 'view_newsdetail', null, null);
    },
    methods: {
        getPublishDate: function () {
            var publishDate = this.detailController.campaign.startDate;
            var message = this.lbl.detail.news_time;

            var result = Moment.unix(publishDate).utc();
            var year = Moment.unix(publishDate).utc().format('YYYY');
            if (this.locale === 1054)
                year = result.get('year') + 543;

            year = year.toString().substring(2, 4);
            var month = result.format('MM');
            var day = result.format('DD');

            var date = `${day}/${month}/${year}`;
            var time = result.format('HH:mm');
            //var monthString = this.lblDate.month_short[result.format('M') - 1];

            return Util.stringFormat(message, date, time);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/module/Detail/component/layout/Layout.scss";
</style>
